export default __webpack_public_path__ + "static/media/global-icon-three.1efbbf00.svg";